import { render } from "./DateSelectorV3.vue?vue&type=template&id=6a2188b2&scoped=true"
import script from "./DateSelectorV3.vue?vue&type=script&lang=ts"
export * from "./DateSelectorV3.vue?vue&type=script&lang=ts"

import "./DateSelectorV3.vue?vue&type=style&index=0&id=6a2188b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a2188b2"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
